"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var MDIcon_1 = require("../../components/MDIcon");
var Button_1 = require("../../components/Button");
require("./IconButton.css");
var R = __importStar(require("../../utils/ramda"));
var extractProps = function (props) {
  var iconKeys = ["icon", "animation", "reverse", "rotation", "color", "size", "background", "svgProps"];
  var iconProps = R.pick(iconKeys, props);
  var buttonProps = R.omit(iconKeys, props);
  return [iconProps, buttonProps];
};
var IconButton = function (props) {
  var _a = __read(extractProps(props), 2),
    iconProps = _a[0],
    _b = _a[1],
    _c = _b.outline,
    outline = _c === void 0 ? false : _c,
    _d = _b.round,
    round = _d === void 0 ? false : _d,
    className = _b.className,
    restProps = __rest(_b, ["outline", "round", "className"]);
  var type = outline ? "secondary" : "tertiary";
  return (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({
    className: (0, classnames_1.default)("vsx-icon-btn", className, round && "rounded")
  }, restProps, {
    type: type
  }, {
    children: (0, jsx_runtime_1.jsx)(MDIcon_1.MDIcon, __assign({}, iconProps, {
      align: "middle"
    }))
  }));
};
exports.IconButton = IconButton;